<script>
export default {
    template: "",
    created: function() {
        window.location.href = "/submittal-manager";
    }
}
</script>
